import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PostLoginResponse } from '../interfaces/post-login';
import { RequestError } from '../interfaces/error.interface';

export interface AuthState {
  token: string | null;
  refreshToken: string | null;
  errorCode: number | null;
}

const initialState: AuthState = {
  token: null,
  refreshToken: null,
  errorCode: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    postLoginInitApiAction: (state) => {
      state.errorCode = null;
    },
    postLoginSuccessApiAction: (
      state,
      action: PayloadAction<PostLoginResponse>
    ) => {
      state.token = action.payload.access_token;
      state.refreshToken = action.payload.refresh_token;
    },
    postLoginFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postGoogleLoginInitApiAction: (state) => {
      state.errorCode = null;
    },
    authClearAction: (state) => {
      state.token = null;
      state.refreshToken = null;
      state.errorCode = null;
    },
  },
});

export const {
  postLoginInitApiAction,
  postLoginSuccessApiAction,
  postLoginFailureApiAction,
  authClearAction,
} = authSlice.actions;

export default authSlice.reducer;
